<template>
<div>
    <h4 class="px-3 py-1">{{$t('message.settings.generalSettings')}}</h4>
    <v-divider></v-divider>
    <form-data :references.sync="formReferences" :model="modelObj" ref="settingsReference" class="pt-2">
      <template slot="custom_fields">
        <v-layout wrap class="pa-0">
          <v-flex sm12 lg8 xs12>
            <v-layout wrap class="pa-0">
              <v-flex sm12 lg6>
                <v-textarea outlined hide-details v-model="modelObj.company_information" :label="$t('message.settings.companyInfo')" dense></v-textarea>
              </v-flex>
              <v-flex sm12 lg6>
                <v-textarea outlined hide-details dense v-model="modelObj.post_address" :label="$t('message.settings.postAddress')"></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm12 lg4 xs12>
            <v-layout wrap class="pa-0">
              <v-flex sm6 lg6>
                <v-text-field outlined hide-details dense v-model="modelObj.contacttelephone" :label="$t('message.settings.contactTelephone')"></v-text-field>
              </v-flex>
              <v-flex sm6 lg6>
                <v-text-field outlined hide-details dense v-model="modelObj.contactemail" :label="$t('message.settings.contactEmail')"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap class="pa-0">
              <v-flex sm6 lg6>
                <v-text-field outlined hide-details dense v-model="modelObj.web" :label="$t('message.customer.web')"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap class="pa-0">
              <v-flex sm12 lg12>
                <v-file-input v-model="modelObj.standardsaletermfile" dense hide-details outlined :label="$t('message.settings.standardInvoiceText')"></v-file-input>
                <template>
                  {{ fileName || '' }}
                </template>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
      <template slot="extraDetails">
        <v-layout wrap class="pa-0 pt-3 pl-3 pr-3 pb-2 wrap">
          <v-flex xs12>
            <h4>{{ $t('message.orders.standardOfferText') }}:</h4>
          </v-flex>
          <v-flex xs12>
            <ckeditor :editor="editor" v-model="modelObj.standradoffertext" :config="editorConfig"></ckeditor>
          </v-flex>
          <v-flex xs12 class="mt-3">
            <h4>{{ $t('message.orders.standardOrderText') }}:</h4>
          </v-flex>
          <v-flex xs12>
            <ckeditor :editor="editor" v-model="modelObj.standradordertext" :config="editorConfig"></ckeditor>
          </v-flex>
          <v-flex xs12 class="mt-3">
            <h4>{{ $t('message.orders.standardDeliveryTerms') }}:</h4>
          </v-flex>
          <v-flex xs12>
            <ckeditor :editor="editor" v-model="modelObj.standraddeliveryterms" :config="editorConfig"></ckeditor>
          </v-flex>
        </v-layout>
      </template>
    </form-data>
    <v-divider></v-divider>
    <v-card-actions>
      <v-layout>
        <v-flex class="text-center">
          <v-btn color="success" @click="saveSettings()">{{ $t('message.common.save') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
</div>
</template>
<script>
import FormTemplate from '@/components/FormTemplate'
import { mapState } from 'vuex'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      modelObj: {
        lock_month_on: 0,
        mininum_hours: 0,
        standardsaletermfile: [],
        standradoffertext: '',
        standraddeliveryterms: '',
        standradordertext: ''
      },
      fileName: '',
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      }
    }
  },
  mounted () {
    this.getSettings()
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    formReferences () {
      return {
        properties: [{
          model: 'organizationnumber',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.settings.organizationNumber'),
          class: 'lg2 md2 sm6'
        }, {
          model: 'partyname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.settings.companyName'),
          class: 'lg2 sm6'
        }, {
          model: 'streetname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.settings.streetName'),
          class: 'lg3 sm6'
        }, {
          model: 'postalzone',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.post'),
          class: 'lg1 md2 sm6'
        }, {
          model: 'cityname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.city'),
          class: 'lg2 sm6'
        }, {
          model: 'contactname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.settings.contactName'),
          class: 'lg2 sm6'
        }, {
          model: 'custom_fields',
          class: 'lg12 xs12'
        }, {
          model: 'payment_label1',
          type: this.FORM_TYPE.LABEL,
          label: `${this.$t('message.customer.paymentmethod')}: Direkte`,
          class: 'lg3 sm6'
        }, {
          model: 'direct_financial_payment_identifier',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.settings.accountNo'),
          class: 'lg2 sm6'
        }, {
          model: 'direct_financial_payment_identifier_international',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.settings.ibanBban'),
          class: 'lg2 md2 sm6'
        }, {
          model: 'direct_financial_institution_branch',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.settings.branchName'),
          class: 'lg3 sm6'
        }, {
          model: 'payment_label',
          type: this.FORM_TYPE.LABEL,
          label: `${this.$t('message.customer.paymentmethod')}: Factoring`,
          class: 'lg3 sm6'
        }, {
          model: 'sg_financial_payment_identifier',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.settings.accountNo'),
          class: 'lg2 sm6'
        }, {
          model: 'sg_financial_payment_identifier_international',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.settings.ibanBban'),
          class: 'lg2 md2 sm6'
        }, {
          model: 'sg_financial_institution_branch',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.settings.branchName'),
          class: 'lg3 sm6'
        }]
      }
    }
  },
  methods: {
    getSettings () {
      this.$_executeApi('get', 'commonsettings').then(response => {
        this.modelObj = response.data
        if (!this.modelObj.standardsaletermfile) {
          this.modelObj.standardsaletermfile = []
        } else {
          this.fileName = this.modelObj.standardsaletermfile
          this.modelObj.standardsaletermfile = []
        }
        if (!this.modelObj.standradoffertext) this.modelObj.standradoffertext = ''
        if (!this.modelObj.standradordertext) this.modelObj.standradordertext = ''
        if (!this.modelObj.standraddeliveryterms) this.modelObj.standraddeliveryterms = ''
      })
    },
    uploadFile (files) {
      let formData = new FormData()
      if (this.modelObj.standardsaletermfile) {
        formData.append(files.name, files)
      }
      return this.$_executeApi('post', 'commonsettings/upload_saleterms_file', formData)
    },
    saveSettings () {
      if (this.$refs.settingsReference.$refs.validateForm.validate()) {
        const model = this.$formatter.cloneVariable(this.modelObj)
        const files = this.modelObj.standardsaletermfile
        model.standardsaletermfile = null
        this.$_executeApi('post', 'commonsettings', model).then(response => {
          this.uploadFile(files).then(() => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
            this.getSettings()
          })
        })
      }
    }
  }
}
</script>
